module.exports = __webpack_public_path__ + "static/media/back.a266ac60.ogv";